<template>
  <v-app>
    <v-container fluid fill-height class="darkbg">
      <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="6"
            md="4"
            align="center"
          >
            <img :src="images.logo" width="150"/>
            <v-card
              class="elevation-12"
              light
            >
              <v-card-title class="pb-0">
                Signup to Customer Portal
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout
                  row
                  fill-height
                  justify-center
                  align-center
                  v-if="loading"
                >
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </v-layout>

                <v-form v-else ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="registration.username"
                    :rules="rules.username"
                    prepend-inner-icon="mdi-account"
                    label="Username"
                    color="primary"
                    autocomplete="username"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="registration.email"
                    :rules="rules.email"
                    prepend-inner-icon="mdi-email-outline"
                    label="Email"
                    color="primary"
                    autocomplete="email"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="registration.password1"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :rules="rules.password"
                    color="primary"
                    :counter="128"
                    maxlength="128"
                    autocomplete="current-password"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="registration.password2"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password (Again)"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :rules="rules.password"
                    color="primary"
                    :counter="128"
                    maxlength="128"
                    autocomplete="current-password"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="registration.first_name"
                    :rules="rules.first_name"
                    :counter="128"
                    prepend-inner-icon="mdi-account"
                    color="primary"
                    label="Firstname"
                    maxlength="128"
                    required
                    autocomplete="firstname"
                  />

                  <v-text-field
                    v-model="registration.last_name"
                    :rules="rules.last_name"
                    prepend-inner-icon="mdi-account"
                    color="primary"
                    :counter="128"
                    label="Lastname"
                    maxlength="128"
                    required
                    autocomplete="lastname"
                    @keyup.enter.native="register"
                  />

                  <v-text-field
                    v-model="registration.organisation"
                    prepend-inner-icon="mdi-domain"
                    color="primary"
                    label="Organisation / Company"
                    :counter="128"
                    maxlength="128"
                    autocomplete="organisation"
                    @keyup.enter.native="register"
                  />

                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  @click="register"
                  block
                  >
                  <v-icon left>mdi-lock</v-icon>
                  Register
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-spacer></v-spacer>
            <v-btn class="text-left" text to="/"><v-icon left dark>mdi-arrow-left</v-icon>Back to Home</v-btn>
          </v-col>
      </v-row>
    </v-container>
    <v-footer>
     <v-spacer></v-spacer>
    <div class="caption">&copy; {{ new Date().getFullYear() }} - Patrowl.io</div>
   </v-footer>
   <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
     <span v-html="snackText"></span>
     <v-btn text @click="snack = false">Close</v-btn>
   </v-snackbar>
  </v-app>
</template>

<script>
// import axios from 'axios';
export default {
  name: 'AppSignup',
  data: () => ({
    valid: true,
    loading: false,
    registration: {
      // 'username': '',
      // 'password': '',
      // 'password_confirm': '',
      // 'email': '',
      // 'first_name': '',
      // 'lastname': '',
      // 'g-recaptcha-response': ''
      'username': '',
      'password1': '',
      'password2': '',
      'email': '',
      'first_name': '',
      'last_name': '',
      'company': '',
      'g-recaptcha-response': ''
    },
    showPassword: false,
    rules: {
      username: [
        v => !!v || "Username is required",
        v => (v && v.length > 4) || "A username must be more than 4 characters long",
        v => /^[a-zA-Z0-9_]+$/.test(v) || "A username can only contain letters and digits",
      ],
      password: [
        v => !!v || "Password is required",
        v => (v && v.length > 8) || "The password must be longer than 8 characters",
        v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
        v => /(?=.*\d)/.test(v) || 'Must have one number',
        v => /([!@#$%-_])/.test(v) || 'Must have one special character [!@#$%-_]'
      ],
      email: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      first_name: [
        v => !!v || 'Firstname is required',
      ],
      last_name: [
        v => !!v || 'Lastname is required',
      ],
    },
    images: {
      // logo: require('@/assets/img/logo-owl-text-large-white.png'),
      logo: require('@/assets/img/logo-patrowl-black.png'),
    },
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  mounted() {
    this.recaptcha();
  },
  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded()
      this.registration['g-recaptcha-response'] = await this.$recaptcha('login');
    },

    register () {
      this.loading = true;
      if (this.valid && this.registration['g-recaptcha-response'] != '') {
        // console.log(this.registration['g-recaptcha-response'])
        this.snack = true;
        this.snackColor = 'grey';
        this.snackText = 'Signup processing... We are working hard in back-office to make this happen. Please wait confirmation';

        var form_data = new FormData();
        form_data.append('username', this.registration['username']);
        form_data.append('password1', this.registration['password1']);
        form_data.append('password2', this.registration['password2']);
        form_data.append('email', this.registration['email']);
        form_data.append('first_name', this.registration['first_name']);
        form_data.append('last_name', this.registration['last_name']);
        form_data.append('company', this.registration['company']);
        form_data.append('g-recaptcha-response', this.registration['g-recaptcha-response']);

        // this.$api.post('/api/public/users/signup', this.registration).then(res => {
        this.$api.post('/api/public/users/signup', form_data).then(res => {
          if (res && res.status === 200 && res.data.status === 'valid') {
            this.snack = true;
            this.snackColor = 'success';
            this.snackText = 'Signup successful. Check confirmation email.';
            // this.$router.push({name: 'AppLogin'});
            setTimeout( () => this.$router.push({name: 'AppLogin'}), 3000);
          } else {
            let errors = ""
            for (var err in res.data.errors) {
              // console.log(res.data.errors[err]);
              errors += err + ": " + res.data.errors[err] + "<br/>"
            }

            this.snack = true;
            this.snackColor = 'error';
            this.snackText = `Error during Signup:<br/>`+errors;
          }
        }).catch(e => {
          console.log(e)
        });
      }
      this.loading = false;
    },
  },
}
</script>
<style scoped>
</style>
